import { useState, useContext } from "react";
import {
  Box,
  Grid,
  Stack,
  Select,
  MenuItem,
  Typography,
  FormControl,
} from "@mui/material";
// import { useLocation } from "react-router-dom";
//Import from project
import "../../Style/pagestyle.scss";
import { AuthContext } from "../../Context/AuthContext";
// import { ButtonCreate, SearchTextField } from "../../Utils/Component";
import EmptyData from "../../Components/Include/EmptyData/EmptyData";
import ClassCard from "../../Components/StudyClass/ClassCard/ClassCard";
import LoadingPage from "../../Utils/LoadingPage";
// import FooterPagination from "../../Utils/FooterPagination";
import useGetClassByTeacherId from "../../Hooks/useGetClassByTeacherId";

export default function ClassForTeacher() {
  // Change Language
  const { t } = useContext(AuthContext);
  const [status, setStatus] = useState("All");
  const handleChange = (event) => setStatus(event.target.value);

  const userLogin = JSON.parse(window.localStorage.getItem("userLogin"));

  const { classData, loading, refetch } = useGetClassByTeacherId({
    id: userLogin?.user?._id,
  });

  return (
    <div className="page-container">
      <Stack direction="column" rowGap={2.2}>
        <Box>
          <Grid container spacing={3}>
            {/* <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
              <Typography className={t("class-name-text-field-title")}>
                {t("search")}
              </Typography>
              <SearchTextField
                className={"text-field"}
                handleSearch={handleSearch}
              />
            </Grid> */}

            <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
              <Typography className={t("class-name-text-field-title")}>
                {t("thead_status")}
              </Typography>
              <FormControl fullWidth size="small" className={"text-field"}>
                <Select value={status} onChange={handleChange}>
                  <MenuItem value={"All"}> {t("thead_all")} </MenuItem>
                  <MenuItem value={false}> {t("thead_studying")} </MenuItem>
                  <MenuItem value={true}> {t("thead_completed")} </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>

        <Grid container spacing={3}>
          {loading ? (
            <Grid item xs={12}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
                sx={{
                  height: 320,
                  width: "100%",
                  bgcolor: "white",
                  borderRadius: 1,
                }}
              >
                <LoadingPage />
              </Stack>
            </Grid>
          ) : classData?.length === 0 || classData?.length === undefined ? (
            <Grid item xs={12}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
                sx={{
                  height: 320,
                  width: "100%",
                  bgcolor: "white",
                  borderRadius: 1,
                }}
              >
                <EmptyData />
              </Stack>
            </Grid>
          ) : (
            classData?.map((data, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4} key={index}>
                <ClassCard data={data} setRefetch={refetch} />
              </Grid>
            ))
          )}
        </Grid>
      </Stack>

      {/* ================================== Pagination ============================= */}
      {/* <FooterPagination
        totalPages={paginationData?.totalPages}
        totalDocs={paginationData?.totalDocs}
        limit={limit}
        page={page}
        setPage={setPage}
        handleLimit={handleLimit}
        setLoading={setLoading}
      /> */}
    </div>
  );
}
